import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const UpdateNews = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const API = "https://gp-chandoli-khurd.com/backend/api";

  const [news, setNews] = useState({
    title: "",
    content: "",
    photo: null,
    pdf_file: null
  });

  const [loading, setLoading] = useState(true);


  useEffect(() => {

    if (!id) return;

    const fetchNews = async () => {

      try {

        const res = await fetch(`${API}/news/get_news_by_id.php?id=${id}`);

        const data = await res.json();

        if (data.status === "success") {

          setNews({
            title: data.news.title,
            content: data.news.content,
            photo: null,
            pdf_file: null
          });

        }

      } catch (error) {

        console.error("Fetch error:", error);

      } finally {

        setLoading(false);

      }

    };

    fetchNews();

  }, [id]);


  const handleChange = (e) => {

    setNews({
      ...news,
      [e.target.name]: e.target.value
    });

  };


  const handleFileChange = (e) => {

    setNews({
      ...news,
      [e.target.name]: e.target.files[0]
    });

  };


  const handleSubmit = async (e) => {

    e.preventDefault();

    const formData = new FormData();

    formData.append("id", id);
    formData.append("title", news.title);
    formData.append("content", news.content);

    if (news.photo) {
      formData.append("photo", news.photo);
    }

    if (news.pdf_file) {
      formData.append("pdf_file", news.pdf_file);
    }

    try {

      const res = await fetch(`${API}/news/update_news.php`, {
        method: "POST",
        body: formData
      });

      const data = await res.json();

      if (data.status === "success") {

        alert("News Updated Successfully");

        navigate("/dashboard/news/read-news");

      } else {

        alert(data.message);

      }

    } catch (error) {

      console.error("Update error:", error);

    }

  };


  if (loading) {

    return (
      <div className="p-6">
        Loading News...
      </div>
    );

  }


  return (

    <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">

      <h2 className="text-2xl font-bold mb-4">
        Update News
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        <div>
          <label className="block font-medium mb-1">
            Title
          </label>

          <input
            type="text"
            name="title"
            value={news.title}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </div>


        <div>
          <label className="block font-medium mb-1">
            Content
          </label>

          <textarea
            name="content"
            value={news.content}
            onChange={handleChange}
            rows="5"
            className="w-full border p-2 rounded"
          />
        </div>


        <div>
          <label className="block font-medium mb-1">
            Change Photo
          </label>

          <input
            type="file"
            name="photo"
            onChange={handleFileChange}
          />
        </div>


        <div>
          <label className="block font-medium mb-1">
            Change PDF
          </label>

          <input
            type="file"
            name="pdf_file"
            onChange={handleFileChange}
          />
        </div>


        <button
          type="submit"
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
        >
          Update News
        </button>

      </form>

    </div>

  );

};

export default UpdateNews;